// 入门: https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
import { Scene, Color3, ShaderMaterial, Effect, Texture } from '@babylonjs/core';
import { GlobalObject } from './../../utils/GlobalObject';
const glsl = require('glslify');
import vertex from './vertex.glsl';
import fragment from './frag.glsl';

export class DiffuseCircleMaterial {
    private static instance: DiffuseCircleMaterial;
    public material?: ShaderMaterial;
    constructor() {
    }
    public static getInstance(): DiffuseCircleMaterial {
        if (!DiffuseCircleMaterial.instance) {
            DiffuseCircleMaterial.instance = new DiffuseCircleMaterial();
        }
        return DiffuseCircleMaterial.instance;
    }
    public init(scene: Scene, color0:Color3,color1:Color3) {
        Effect.ShadersStore['customVertexShader'] = vertex;
        Effect.ShadersStore['customFragmentShader'] = fragment;
        this.material = new ShaderMaterial("custom", scene as any, 'custom',
            {
                attributes: ["position", "normal", "uv"],
                uniforms: ["world", "worldView", "worldViewProjection", "view", "projection", "direction", "time"],
                needAlphaBlending: true,
                needAlphaTesting: true
            });
        this.material.backFaceCulling = false;
        this.material.setColor3("color0", color0);
        this.material.setColor3("color1", color1);
        var mainTexture = new Texture(GlobalObject.getInstance().main.source.common.p04, scene as any); 
        this.material.setTexture("texture1", mainTexture);
        var time = 0;
        scene.registerBeforeRender(() => {
            time+= 0.01;
            this.material?.setFloat("iTime", time);
        });
    }
}